export const FACTION_IDS = ["concord", "helion", "nomads"] as const;
export type FactionId = (typeof FACTION_IDS)[number];

export interface FactionDefinition {
  id: FactionId;
  name: string;
  description: string;
  color: string;
}

export const FACTIONS: Record<FactionId, FactionDefinition> = {
  concord: {
    id: "concord",
    name: "Содружество",
    description: "Союз колоний, защищающих торговые пути и независимость своих миров.",
    color: "#66d9df",
  },
  helion: {
    id: "helion",
    name: "Директорат Гелиона",
    description: "Промышленные миры, объединённые дисциплиной дальних экспедиций.",
    color: "#e7b868",
  },
  nomads: {
    id: "nomads",
    name: "Вольные системы",
    description: "Свободные капитаны и пограничные поселения, выбирающие собственный курс.",
    color: "#b99be8",
  },
};
